import { Result } from 'antd';
import { useLocation } from 'react-router-dom';
import { can, canAny } from '../../util/permission';
import usePermissionVersion from '../../hooks/usePermission';
import IncomeTab from './tabs/IncomeTab';
import WithdrawTab from './tabs/WithdrawTab';
import VatTab from './tabs/VatTab';
import AuthTab from './tabs/AuthTab';
import OrderTab from './tabs/OrderTab';
import './finance.css';

const TAB_DEFS = [
  { key: 'income', label: '收入与扣税台账', perm: 'finance:income:list', node: <IncomeTab /> },
  { key: 'withdraw', label: '提现与资金流水', perm: 'finance:withdraw:list', node: <WithdrawTab /> },
  { key: 'vat', label: '增值税代办台账', perm: 'finance:vat:list', node: <VatTab /> },
  { key: 'auth', label: '授权存证管理', perm: 'finance:auth:list', node: <AuthTab /> },
  { key: 'order', label: '平台订单明细', perm: 'finance:order:list', node: <OrderTab /> },
];

function currentTabKey(pathname) {
  const segments = (pathname || '').split('/').filter(Boolean);
  const last = segments[segments.length - 1];
  return TAB_DEFS.some((item) => item.key === last) ? last : undefined;
}

export default function FinancePage() {
  usePermissionVersion();
  const { pathname } = useLocation();

  if (!canAny('finance:')) {
    return <Result status="403" title="无权限访问财务管理" subTitle="请联系管理员分配财务角色" />;
  }

  const tabs = TAB_DEFS.filter((item) => can(item.perm));
  if (tabs.length === 0) {
    return <Result status="403" title="无可查看的财务模块" subTitle="请联系管理员分配财务菜单权限" />;
  }

  const key = currentTabKey(pathname);
  const active = tabs.find((item) => item.key === key) || tabs[0];

  return <div className="finance-page">{active.node}</div>;
}
